export class NotFoundError extends Error {
  constructor(url) {
    super(`Нет данных по указанному адресу! ${url}`);
    this.name = 'NotFoundError';
  }
}
